<template> 
                    <!-- <div class="location_indicator"></div> -->
    
           <div class="spinner-border text-secondary center"  role="status">
                <span class="sr-only">Loading...</span>
            </div>
    
</template>
<style lang="scss"> 
.location_indicator{
    margin-left: 100px;
    position: relative;
   
}

.location_indicator:before, .location_indicator:after{
    position: absolute;
    content: "";
}

.location_indicator:before{
    width: 20px;
    height: 20px;
    left: 49px;
    border-radius: 100% 100% 100% 0;
    box-shadow: 0px 0px 0px 2px #59664a;
    -webkit-animation: mapping 1s linear infinite;
       -moz-animation: mapping 1s linear infinite;
            animation: mapping 1s linear infinite;
    -webkit-transform: rotate(-46deg);
       -moz-transform: rotate(-46deg);
            transform: rotate(-46deg);

}

.location_indicator:after{
    width: 30px;
    height: 10px;
    border-radius: 100%;
    left: 44px;
    background-color:  #d6ddab;
    top: 24px;
    z-index: -1;
}

@-webkit-keyframes mapping{
    0% {top: 0;}
    50%{top: -5px;}
    100% {top:0; }
}
@-moz-keyframes mapping{
    0% {top: 0;}
    50%{top: -5px;}
    100% {top:0; }
}
@-keyframes mapping{
    0% {top: 0;}
    50%{top: -5px;}
    100% {top:0; }
}

</style>
<script>
export default {
    name:'LoadingLocation'
}
</script>